module.exports = __webpack_public_path__ + "static/img/land2.8ff6137.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/land2.svg
// module id = tdZ4
// module chunks = 0